import React from 'react';
import {useNavigate} from 'react-router';
import {HeaderHeight} from 'theme/settings';
import {useLocalization} from '../../localization';
import {px2rem} from '../../theme';
import {ActionButton} from '../button';
import {Card} from '../card';
import {Layout} from '../layout';
import {Spacer} from '../spacer';
import {Text} from '../text';

type Props = {
  error?: string;
  applySceneHeight?: boolean;
};
export const SceneError: React.FC<Props> = ({error, applySceneHeight}) => {
  const {t} = useLocalization();
  const navigate = useNavigate();

  return (
    <Layout
      adjustCenter
      paddingTop="20vh"
      mt={applySceneHeight ? `${HeaderHeight}px` : 0}>
      <Layout sx={{maxWidth: px2rem(480)}}>
        <Card color="secondary">
          <Layout p={2} adjustCenter>
            <Text variant="h3" kind="error">
              {error ?? t('error.failedToLoadPage')}
            </Text>
            <Spacer size={4} />
            <Layout sx={{minWidth: px2rem(120)}}>
              <ActionButton
                title={t('error.retry')}
                onClick={() =>
                  navigate(`${location.pathname}${location.search}`)
                }
              />
            </Layout>
          </Layout>
        </Card>
      </Layout>
    </Layout>
  );
};
